module.exports = __webpack_public_path__ + "img/cancel.b5fa36f4.svg";